import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ControlledVocab } from '@folio/stripes/smart-components';
import {
  IntlConsumer,
  TitleManager,
} from '@folio/stripes/core';
import { getSourceSuppressor } from '@folio/stripes/util';

import { RECORD_SOURCE } from '../constants';
import validateNameAndCode from './validateNameAndCode';

class ResourceTypesSettings extends React.Component {
  static propTypes = {
    stripes: PropTypes.shape({
      connect: PropTypes.func.isRequired,
      hasPerm: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);

    this.connectedControlledVocab = props.stripes.connect(ControlledVocab);
  }

  render() {
    const hasPerm = this.props.stripes.hasPerm('ui-inventory.settings.instance-types');
    const suppress = getSourceSuppressor([
      RECORD_SOURCE.RDA_CONTENT,
      RECORD_SOURCE.CONSORTIUM,
    ]);

    return (
      <IntlConsumer>
        {intl => (
          <TitleManager
            page={intl.formatMessage({ id: 'ui-inventory.settings.inventory.title' })}
            record={intl.formatMessage({ id: 'ui-inventory.resourceTypes' })}
          >
            <this.connectedControlledVocab
              {...this.props}
              baseUrl="instance-types"
              records="instanceTypes"
              label={<FormattedMessage id="ui-inventory.resourceTypes" />}
              labelSingular={intl.formatMessage({ id: 'ui-inventory.resourceType' })}
              objectLabel={<FormattedMessage id="ui-inventory.resourceTypes" />}
              visibleFields={['name', 'code', 'source']}
              columnMapping={{
                name: intl.formatMessage({ id: 'ui-inventory.name' }),
                code: intl.formatMessage({ id: 'ui-inventory.code' }),
                source: intl.formatMessage({ id: 'ui-inventory.source' }),
              }}
              readOnlyFields={['source']}
              itemTemplate={{ source: 'local' }}
              hiddenFields={['description', 'numberOfObjects']}
              nameKey="name"
              // columnWidths={{ 'name': 300, 'code': 50 }}
              actionSuppressor={{ edit: suppress, delete: suppress }}
              id="instance-types"
              sortby="name"
              validate={validateNameAndCode}
              editable={hasPerm}
            />
          </TitleManager>
        )}
      </IntlConsumer>
    );
  }
}

export default ResourceTypesSettings;
